<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button *ngIf="showButton === 'menu'"></ion-menu-button>
      <ion-back-button *ngIf="showButton === 'back'" defaultHref="" text="" (click)="closeModal()">
      </ion-back-button>
      <!-- <ion-button *ngIf="false" style="--color: #adadad" [routerLink]="routeInfo?.url"
        [routerDirection]="routeInfo?.direction">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button> -->
    </ion-buttons>

    <ion-title [ngClass]="(canShowCart() ? 'has-cart-icon' : '')">
      <div *ngIf="title != 'Home'" style="color: #444444;"> {{title}} </div>
      <ion-img *ngIf="title == 'Home'" class="title-image" [src]="logoUrl"></ion-img>
    </ion-title>

    <ion-button class="btn-right-group cart-icon" *ngIf="canShowCart()" (click)="openCartPage()" slot="end" fill="clear"
      color="secondary">
      <span *ngIf="(cartItems.length ? true : false)" [ngClass]="(cartItems.length ? 'active' : null)">{{
        cartTotalProductsQty }}</span>
      <ion-icon name="cart-outline">
      </ion-icon>
    </ion-button>

    <ion-button class="btn-right-group" *ngIf="canShow()" (click)="openNotificationPage()" slot="end" fill="clear"
      color="secondary">
      <span [ngClass]="isUnreadNotification() ? 'active' : null "></span>
      <ion-icon name="notifications-outline">
      </ion-icon>
    </ion-button>
    <!-- <ion-button class="btn-right-group" *ngIf="canShow()" slot="end" fill="clear">
      <ion-icon name="settings-sharp"></ion-icon>
    </ion-button> -->

  </ion-toolbar>
</ion-header>